<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M52.13 18.54L34 8a4 4 0 00-4 0L11.87 18.54A3.72 3.72 0 0010 21.71v20.61a3.7 3.7 0 001.87 3.18L30 56a4 4 0 004 0l18.13-10.5A3.68 3.68 0 0054 42.32v-20.6a3.68 3.68 0 00-1.87-3.18zm-20.61-7.91a1 1 0 01.95 0l16.91 9.79-7.1 3.91-17.64-9.72zM32 30l-17.37-9.59 7-4L39.17 26zM13.37 42.9a.67.67 0 01-.37-.58V22.94l17.51 9.63v20.21zm37.26 0L33.5 52.79V32.57L51 23v19.32a.67.67 0 01-.37.58z"/></svg>